import React, { useState, useRef, useEffect, useCallback } from 'react';
import { Rate, Button, Carousel, App } from 'antd';
import styles from './index.module.scss';
import { useNavigate, useParams } from 'react-router-dom';
import { getServiceWebProductDetail } from '@/api/Services';
import {
  getMerchantInfo
} from '@/api/store';
import { saveToCart } from '@/api/cart';
import { HeartOutlined, HeartFilled } from '@ant-design/icons';
import { useAppSelector } from '@/store/hooks';
import { createChatRoom } from '@/api/message';
import { useTranslation } from 'react-i18next';

import icon1 from '@/assets/images/组 2387@2x.png';
import icon2 from '@/assets/images/路径 1659@2x.png';
import pic1 from '@/assets/images/Merchant _url.png';

import ProductBanner from '@/components/ProductBanner/ProductBanner';
import ProductDetailTemplate1 from '@/pages/StorePublishProduct/components/Template/ProductDetailTemplate1/ProductDetailTemplate1';
import ProductDetailTemplate2 from '@/pages/StorePublishProduct/components/Template/ProductDetailTemplate2/ProductDetailTemplate2';
import ProductDetailTemplate3 from '@/pages/StorePublishProduct/components/Template/ProductDetailTemplate3/ProductDetailTemplate3';
import ProductDetailTemplate4 from '@/pages/StorePublishProduct/components/Template/ProductDetailTemplate4/ProductDetailTemplate4';
import ProductDetailTemplate5 from '@/pages/StorePublishProduct/components/Template/ProductDetailTemplate5/ProductDetailTemplate5';
import ProductDetailTemplate6 from '@/pages/StorePublishProduct/components/Template/ProductDetailTemplate6/ProductDetailTemplate6';
import ProductDetailTemplate7 from '@/pages/StorePublishProduct/components/Template/ProductDetailTemplate7/ProductDetailTemplate7';
import CartCounter from '@/components/CartCounter';

const ProductDetail: React.FC = () => {
  const navigate = useNavigate();
  const params = useParams();
  const { message } = App.useApp();
  const { t } = useTranslation();
  //店铺评分
  const [value, setValue] = useState(5);

  //购物车计数器
  const [count, setCount] = useState(1);

  //计数器是否禁用
  const [countDisabled, setCountDisabled] = useState(false);

  // 店铺详情
  const [merchantInfo, setMerchantInfo] = useState<any>({});

  //表单的总数据
  const [formDataAll, setFormDataAll] = useState<any>(

    {
      // "service_product_value": {
      //   "service_id": 31,
      //   "product_category": {
      //     "product_category_id": 20,
      //     "product_category_name": "Phone",
      //     "product_category_type_id": 1,
      //     "product_category_type_name": "Goods",
      //     "parent_id": 0,
      //     "is_active": true,
      //     "is_delete": false,
      //     "order_by": null
      //   },
      //   "service_name": "\u624b\u673a\u7ef4\u4fee",
      //   "service_description": "Service Description",
      //   "create_time": "2025-08-15T08:40:12.176Z",
      //   "update_time": "2025-08-15T08:40:12.176Z",
      //   "user": {
      //     "user_id": "cdadex1753145453245",
      //     "merchant_id": "MER-B2D0EF43",
      //     "first_name": "client",
      //     "last_name": "53245",
      //     "nick_name": "townloop\u5c0f\u5e97",
      //     "username": "494313281@qq.com",
      //     "email": "494313281@qq.com",
      //     "phone": "",
      //     "photo": "http://192.168.3.158:8001/api/web/files/uploads/images/7fa890a6-7aa5-4fb0-8b07-a5e254ebd678.png",
      //     "gender": 0,
      //     "birthday": null,
      //     "level": 0,
      //     "is_delete": false,
      //     "create_time": "07/22/2025 00:50:53",
      //     "update_time": "08/14/2025 08:19:26"
      //   },
      //   "reservation_time_slots": [
      //     "09:00 - 12:00",
      //     "12:00 - 13:00",
      //   ],
      //   service_detail_content:[
      //     {
      //       name: 'template1',
      //       title: 'Lightweight and portable',
      //       content: 'The lightweight structure makes it easy to use at home or on the go, adding convenience to your everyday life.',
      //       imgUrl: [
      //         {
      //           url: "https://www.easysolarsupply.com/api/upload_files/090c1c01851c44b69769e3294beba6ba.png",
      //           name: "",
      //         },
      //       ]
      //     },
      //     {
      //       name: 'template2',
      //       title: 'Handwoven with care',
      //       content: 'Each basket is carefully handwoven by skilled artisans, offering both durability and a unique, natural charm.',
      //       imgUrl: [
      //         {
      //           url: "https://www.easysolarsupply.com/api/upload_files/090c1c01851c44b69769e3294beba6ba.png",
      //           name: "",
      //         },
      //       ]
      //     },
      //     {
      //       name: 'template3',
      //       bottomTitle: 'Dominique Galvan',
      //       contentList: [
      //         {
      //           title: 'Dominique Galvan',
      //           content: 'Dominique Galvan ',
      //         },
      //         {
      //           title: 'Dominique Galvan',
      //           content: 'Dominique Galvan ',
      //         },
      //         {
      //           title: 'Dominique Galvan',
      //           content: 'Dominique Galvan ',
      //         },
      //       ],
      //       imgUrl: [
      //         {
      //           url: "https://www.easysolarsupply.com/api/upload_files/090c1c01851c44b69769e3294beba6ba.png",
      //           name: "",
      //         },
      //       ]
      //     },
      //     {
      //       name: 'template4',
      //       contentList: [
      //         {
      //           title: 'Square Storage Basket',
      //           content1: '13.78*9.84* 5.91',
      //           content2: 'Natural bamboo strips',
      //           imgUrl: [
      //             {
      //               url: "https://www.easysolarsupply.com/api/upload_files/090c1c01851c44b69769e3294beba6ba.png",
      //               name: "",
      //             },
      //           ]
      //         },
      //         {
      //           title: 'Striped Handheld Basket',
      //           content1: '13.78*9.84* 5.91',
      //           content2: 'Natural bamboo strips',
      //           imgUrl: [
      //             {
      //               url: "https://www.easysolarsupply.com/api/upload_files/090c1c01851c44b69769e3294beba6ba.png",
      //               name: "",
      //             },
      //           ]
      //         },
      //         {
      //           title: 'Dominique Galvan',
      //           content1: '13.78*9.84* 5.91',
      //           content2: 'Natural bamboo strips',
      //           imgUrl: [
      //             {
      //               url: "https://www.easysolarsupply.com/api/upload_files/090c1c01851c44b69769e3294beba6ba.png",
      //               name: "",
      //             },
      //           ]
      //         },
      //       ],
        
      //     },
        
      //     {
      //       name: 'template5',
      //       imgUrl: [
      //         {
      //           url: "https://www.easysolarsupply.com/api/upload_files/090c1c01851c44b69769e3294beba6ba.png",
      //           name: "",
      //         },
      //       ]
      //     },
         
         
      //   ]
      // },
      // "product_main_images": [
      //   {
      //     "id": 81,
      //     "service_product": {
      //       "service_id": 31,
      //       "product_category": {
      //         "product_category_id": 20,
      //         "product_category_name": "Phone",
      //         "product_category_type_id": 1,
      //         "product_category_type_name": "Goods",
      //         "parent_id": 0,
      //         "is_active": true,
      //         "is_delete": false,
      //         "order_by": null
      //       },
      //       "service_name": "\u624b\u673a\u7ef4\u4fee",
      //       "service_description": "Service Description",
      //       "create_time": "2025-08-15T08:40:12.176Z",
      //       "update_time": "2025-08-15T08:40:12.176Z",
      //       "user": {
      //         "user_id": "cdadex1753145453245",
      //         "merchant_id": "MER-B2D0EF43",
      //         "first_name": "client",
      //         "last_name": "53245",
      //         "nick_name": "townloop\u5c0f\u5e97",
      //         "username": "494313281@qq.com",
      //         "email": "494313281@qq.com",
      //         "phone": "",
      //         "photo": "http://192.168.3.158:8001/api/web/files/uploads/images/7fa890a6-7aa5-4fb0-8b07-a5e254ebd678.png",
      //         "gender": 0,
      //         "birthday": null,
      //         "level": 0,
      //         "is_delete": false,
      //         "create_time": "07/22/2025 00:50:53",
      //         "update_time": "08/14/2025 08:19:26"
      //       },
      //       "reservation_time_slots": [
      //         "09:00 - 12:00"
      //       ]
      //     },
      //     "media_type": 1,
      //     "file": {
      //       "id": 420,
      //       "original_name": "1.png",
      //       "encrypted_name": "61341a70-cf69-48a2-891f-7c912a758864.png",
      //       "host": "http://192.168.3.158:8001/api/web/files/",
      //       "file": "uploads/images/61341a70-cf69-48a2-891f-7c912a758864.png",
      //       "size": 1596648,
      //       "content_type": "image/png",
      //       "upload_time": "08/15/2025 08:34:34"
      //     },
      //     "media_file_url": "http://test.townloop.app:8002/api/web/files/uploads/images/baa01763-61af-4b13-9927-edea2c99baaf.png",
      //     "create_time": "2025-08-15T08:40:12.181Z"
      //   },
      //   {
      //     "id": 82,
      //     "service_product": {
      //       "service_id": 31,
      //       "product_category": {
      //         "product_category_id": 20,
      //         "product_category_name": "Phone",
      //         "product_category_type_id": 1,
      //         "product_category_type_name": "Goods",
      //         "parent_id": 0,
      //         "is_active": true,
      //         "is_delete": false,
      //         "order_by": null
      //       },
      //       "service_name": "\u624b\u673a\u7ef4\u4fee",
      //       "service_description": "Service Description",
      //       "create_time": "2025-08-15T08:40:12.176Z",
      //       "update_time": "2025-08-15T08:40:12.176Z",
      //       "user": {
      //         "user_id": "cdadex1753145453245",
      //         "merchant_id": "MER-B2D0EF43",
      //         "first_name": "client",
      //         "last_name": "53245",
      //         "nick_name": "townloop\u5c0f\u5e97",
      //         "username": "494313281@qq.com",
      //         "email": "494313281@qq.com",
      //         "phone": "",
      //         "photo": "http://192.168.3.158:8001/api/web/files/uploads/images/7fa890a6-7aa5-4fb0-8b07-a5e254ebd678.png",
      //         "gender": 0,
      //         "birthday": null,
      //         "level": 0,
      //         "is_delete": false,
      //         "create_time": "07/22/2025 00:50:53",
      //         "update_time": "08/14/2025 08:19:26"
      //       },
      //       "reservation_time_slots": [
      //         "09:00 - 12:00"
      //       ]
      //     },
      //     "media_type": 1,
      //     "file": {
      //       "id": 421,
      //       "original_name": "2.png",
      //       "encrypted_name": "3cd8f503-1e65-4fce-8bc0-5700f6e4ecaa.png",
      //       "host": "http://192.168.3.158:8001/api/web/files/",
      //       "file": "uploads/images/3cd8f503-1e65-4fce-8bc0-5700f6e4ecaa.png",
      //       "size": 1597232,
      //       "content_type": "image/png",
      //       "upload_time": "08/15/2025 08:34:34"
      //     },
      //     "media_file_url": "http://test.townloop.app:8002/api/web/files/uploads/images/1998dd19-dc93-4ffe-96ea-11d26bcba3e5.png",
      //     "create_time": "2025-08-15T08:40:12.184Z"
      //   }
      // ],
      // "sales_specifications": [
      //   {
      //     "name": "\u66f4\u6362\u7535\u6c60",
      //     "price": "100.00",
      //     "duration": 100,
      //     "is_on_shelf": true
      //   },
      //   {
      //     "name": "\u66f4\u6362\u4e3b\u677f",
      //     "price": "300.00",
      //     "duration": 100,
      //     "is_on_shelf": true
      //   }
      // ],
      // service_product_detail_content:[]
    }
  );



  //轮播图图片
  const [imgList, setImgList] = useState<string[]>([
    // 'https://img.alicdn.com/imgextra/i2/2563725160/O1CN01yL26rH1nzKefzLlpN_!!0-item_pic.jpg_.webp',
  ]);



  // 当前选中的sku对象
  const [matchedSKU, setMatchedSKU] = useState<any>({
    name: "",
    price: "",
    duration: 0,
    is_on_shelf: true
  });



  //选中的服务规格，默认第一个
  const [selectedSpecIndex, setSelectedSpecIndex] = useState<number>(0);





  //计数器change事件
  const handleCountChange = (newCount: number) => {
    console.log(newCount);

    setCount(newCount);
  };


  // 处理SKU选项点击
  const handleSpecClick = (valueIndex: number) => {
    setSelectedSpecIndex(valueIndex);
    setMatchedSKU(formDataAll?.sales_specifications[valueIndex]);
    console.log('服务项目',formDataAll?.sales_specifications[valueIndex]);
  };

  //选中的服务时间段
  const [selectedTimeIndex, setSelectedTimeIndex] = useState<number>(0);

  // 处理服务时间段点击
  const handleTimeClick = (valueIndex: number) => {
    setSelectedTimeIndex(valueIndex);
    console.log('服务时间',formDataAll?.service_product_value?.reservation_time_slots[valueIndex]);
    
  };

  


  // 移动端
  const onChange = (currentSlide: number) => {
    // console.log(currentSlide);
  };

  //购买按钮
  const handleBuyNow = () => {

    const selectedTime =  formDataAll?.service_product_value?.reservation_time_slots[selectedTimeIndex];
   
    const productsToOrder = [{
      selectedTime,
      specifications_id:matchedSKU.id,
      service_id: formDataAll?.service_product_value?.service_id,
      quantity: count,
      sales_attributes_id:formDataAll?.sales_attributes[selectedSpecIndex].id,
    }];

    console.log(productsToOrder,'productsToOrder');
    
    const encodedData = JSON.stringify(productsToOrder);

    navigate(`/ServicePlaceOrder?productsToOrder=${encodedData}`);
  }



  // 打开聊天室
  const handleCreateChatRoom = () => {
    createChatRoom({ member_id: formDataAll?.service_product_value?.user?.user_id || '' }).then((res) => {
      if (res.code == 200) {
        navigate(`/chatList?chatRoomId=${res.data.room_id}`);
      } else {
        message.error(res.message);

      }
    });
  }


 


 

  //mounted
  useEffect(() => {
    if (params.id) {
      console.log(params.id);
      // 获取商品详情
      getServiceWebProductDetail({ service_id: params.id }).then((res) => {
        console.log(res, 'res');
        if (res.code === 200) {

          setFormDataAll(res.data); //暂时注释

          //默认选中服务项目的第一项
          setMatchedSKU(res.data?.sales_specifications?.[selectedSpecIndex] || {});

          setImgList(res.data.product_main_images?.map((item: any) => item.media_file_url) || []);

          //获取店铺详情
          getMerchantInfo({ merchant_id: res.data.service_product_value.merchant.merchant_id }).then((res) => {
            if (res.code == 200) {
              setMerchantInfo(res.data);
            }
          })
        }
      });
    }





  }, []);


  return (
    <div className={styles['product-detail']}>

      <Carousel afterChange={onChange} className={styles.Carousel} autoplay>
        {
          imgList?.map((item, index) => (
            <div key={index}>
              <img src={item} alt="" className={styles.bannerBoxMiddleImg} />
            </div>
          ))
        }
      </Carousel>

      {/* 详情页头部 */}
      <div className={styles['product-detail-top-box']}>

        <div className={styles['product-name-box']}>
          <img src={merchantInfo?.merchant_logo_file_url || pic1} alt="" className={styles['product-name-img']} />
          <div className={styles['product-name-right']}>
            <div className={styles['product-name-text1']}>
              {merchantInfo?.merchant_name}
            </div>
            <div className={styles['product-name-text2-box']}>
              <div className={styles['product-name-star']}>
                <Rate onChange={setValue} value={value} disabled className={styles['custom-rate']} />
                <span className={styles['product-star-value']}>{value.toFixed(1)}</span>
              </div>
              <div className={styles['product-name-text2']}>{t('ServiceProductDetail.highQualityService')}</div>
            </div>
          </div>
        </div>

        <div className={`${styles['product-name-text2']} ${styles['product-name-text3']}`}>{t('ServiceProductDetail.highQualityService')}</div>


        <div className={styles['product-btn-box']}>
          <div className={styles['product-btn1']} onClick={handleCreateChatRoom}>
            <img src={icon1} alt="" />
            {t('ServiceProductDetail.contactCustomerService')}
          </div>
          <div className={styles['product-btn2']} onClick={() => navigate(`/storeDetail/${merchantInfo?.merchant_id}`)}>
            <img src={icon2} alt="" />
            {t('ServiceProductDetail.enterStore')}
          </div>
        </div>

      </div>
      {/* 详情页头部 */}

      {/* 详情页正文 */}
      <div className={styles['product-detail-content']}>

        <div className={styles['product-detail-content-left']}>
          <div className={styles['product-detail-content-ProductBanner']}>
            <ProductBanner imgList={imgList} />
          </div>

          <div className={styles['product-detail-img-detail']}>
            {
              formDataAll?.service_product_detail_content?.map((item: any, index: number) => {
                if (item.name === 'template1') {
                  return (
                    <div key={index} className={styles['template-container']}>

                      <ProductDetailTemplate1 data={item} editable={false} />
                    </div>
                  )
                } else if (item.name === 'template2') {
                  return (
                    <div key={index} className={styles['template-container']}>

                      <ProductDetailTemplate2 data={item} editable={false} />
                    </div>
                  )
                } else if (item.name === 'template3') {
                  return (
                    <div key={index} className={styles['template-container']}>

                      <ProductDetailTemplate3 data={item} editable={false} />
                    </div>
                  )
                } else if (item.name === 'template4') {
                  return (
                    <div key={index} className={styles['template-container']}>

                      <ProductDetailTemplate4 data={item} editable={false} />
                    </div>
                  )
                } else if (item.name === 'template5') {
                  return (
                    <div key={index} className={styles['template-container']}>

                      <ProductDetailTemplate5 data={item} editable={false} />
                    </div>
                  )
                } else if (item.name === 'template6') {
                  return (
                    <div key={index} className={styles['template-container']}>

                      <ProductDetailTemplate6 data={item} editable={false} />
                    </div>
                  )
                } else if (item.name === 'template7') {
                  return (
                    <div key={index} className={styles['template-container']}>

                      <ProductDetailTemplate7 data={item} editable={false} />
                    </div>
                  )
                }
                return null;
              })
            }
          </div>
        </div>


        <div className={styles['product-detail-content-right']}>
          <div className={styles['product-detail-name']}>
            {formDataAll?.service_product_value?.service_name || ''}
          </div>

          <div className={styles['product-detail-tag-list']}>
            <div className={styles['product-detail-tag-item']}>{t('ServiceProductDetail.sameDayRepair')}</div>
            <div className={styles['product-detail-tag-item']}>{t('ServiceProductDetail.fastResponse')}</div>
            <div className={styles['product-detail-tag-item']}>{t('ServiceProductDetail.licensedInsured')}</div>
            <div className={styles['product-detail-tag-item']}>{t('ServiceProductDetail.noHiddenFees')}</div>
          </div>

          <div className={styles['product-detail-price-box']}>
            <div className={styles['product-detail-price']}>${matchedSKU?.price || ''}</div>
            {/* 打折模式的原价 暂时隐藏 */}
            {/* <div className={styles['product-detail-price-origin']}>${matchedSKU?.product_price || ''}</div> */}
          </div>

          {/* 免费送货的提示，暂时没有功能先隐藏 */}
          {/* 
          <div className={styles['product-detail-shipping-box']}>
            <div className={styles['product-detail-shipping-item']}>
              <img src={icon3} alt="" />
              <span>Free shipping for this item</span>
            </div>
            <div className={styles['product-detail-shipping-line']}></div>
            <div className={styles['product-detail-shipping-item']}>
              <img src={icon3} alt="" />
              <span>$5.00 Credit for delay</span>
            </div>
          </div> */}


          <div className={styles['product-detail-sku-box']}>
            <div className={styles['sku-spec-group']}>
              <div className={styles['sku-spec-label']}>{t('ServiceProductDetail.serviceType')}：</div>
              <div className={styles['sku-spec-options']}>
                {formDataAll?.sales_specifications?.map((item: any, valueIndex: number) => (
                  <div
                    key={valueIndex}
                    className={`${styles['sku-spec-option']} ${selectedSpecIndex === valueIndex
                      ? styles['sku-spec-option-selected']
                      : ''
                      }`}
                    onClick={() => handleSpecClick(valueIndex)}
                  >
                    {item.name}
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className={styles['product-detail-sku-box']}>
            <div className={styles['sku-spec-group']}>
              <div className={styles['sku-spec-label']}>{t('ServiceProductDetail.availableTimeSlots')}：</div>
              <div className={styles['sku-spec-options']}>
                {formDataAll?.service_product_value?.reservation_time_slots?.map((item: any, valueIndex: number) => (
                  <div
                    key={valueIndex}
                    className={`${styles['sku-spec-option']} ${selectedTimeIndex === valueIndex
                      ? styles['sku-spec-option-selected']
                      : ''
                      }`}
                    onClick={() => handleTimeClick(valueIndex)}
                  >
                    {item}
                  </div>
                ))}
              </div>
            </div>
          </div>


          <div className={styles['product-detail-Quantity-box']}>
            <div className={styles['product-detail-Quantity-text1']}>{t('ServiceProductDetail.quantity')}</div>
            <CartCounter
              disabled={countDisabled}
              initialValue={count}
              onChange={handleCountChange}
              max={100}
            />

            
          </div>


          <div className={styles['product-detail-buy-box']}>

            <Button
              className={styles['product-detail-buy-btn']}
              onClick={handleBuyNow}
            >{t('ServiceProductDetail.orderButton')}</Button>
          </div>


          {/* 自定义属性先隐藏 */}
          {/* <div className={styles['product-detail-type-box']}>
            {
              formDataAll.product_custom_attributes.map((item, index) => {
                return <div key={index} className={styles['product-detail-type-item']}>
                  <div className={styles['product-detail-type-text1']}>{item.attribute_name}:</div>
                  <div className={styles['product-detail-type-text2']}>{item.attribute_value}</div>
                </div>
              })
            }

          </div> */}


        </div>
      </div>
      {/* 详情页正文 */}

    </div>
  );
};

export default ProductDetail; 